import React, { PropTypes } from 'react';
import Reflux from 'reflux';
import Modal from 'react-bootstrap/lib/Modal';
import Revelr from 'configs';
import UserActions from 'actions/userActions';
import UserStore from 'stores/userStore';
import Form from 'form';
import { Client } from 'api';
import Tracker from 'tracker';
import AlertActions from 'actions/alertActions';
import LeadActions from 'actions/leadActions';
import ActiveButton from 'components/activeButton';
import NewMessage from 'components/events/newMessage';
import CardSelector from 'components/leads/cardSelector';
import { CheckboxField } from 'components/forms';

const FIELD_MAP = {
    'card[name]': 'name',
    'number': 'card_number',
    'card[cvc]': 'cvc',
    'card[exp_month]': 'exp_month',
    'card[exp_year]': 'exp_year',
    // These are dupes but I've seen both in responses from Stripe.
    // @TODO - @steves To investigate this further
    'exp_month': 'exp_month',
    'exp_year': 'exp_year',
};

const METHOD_CREDITS = 'credits';
const METHOD_CARD = 'card';

const CARD_FORM_FIELDS = {
    card_number: {
        label: 'Card Number',
        validators: ['required'],
    },
    name: {
        label: 'Name on Card',
        validators: ['required'],
    },
    cvc: {
        label: 'CVC',
        validators: ['required', 'numeric'],
    },
    exp_month: {
        label: 'Expiration Month',
        validators: ['required', 'month'],
    },
    exp_year: {
        label: 'Expiration Year',
        validators: ['required', 'year'],
    },
};

class AcceptModal extends Reflux.Component {
    constructor(props) {
        super(props);

        this.api = new Client();
        this.tracker = new Tracker();
        this.form = new Form(CARD_FORM_FIELDS);
        this.store = UserStore;

        this.handleToggle = this.handleToggle.bind(this);
        this.handleCardFormChanged = this.handleCardFormChanged.bind(this);
        this.handleMessageChanged = this.handleMessageChanged.bind(this);
        this.handleAttachmentsChanged = this.handleAttachmentsChanged.bind(this);
        this.handleCardOptionClicked = this.handleCardOptionClicked.bind(this);
        this.handleCreditsOptionClicked = this.handleCreditsOptionClicked.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSaveAsDefaultChecked = this.handleSaveAsDefaultChecked.bind(this);

        this.state = {
            isModalOpen: this.props.open || false,
            saving: false,
            cardSelected: 'new',
            cardToken: null,
            cards: [],
            newCard: {},
            errors: {},
            newMessage: '',
            newMessageError: '',
            messageModified: false,
            saveMessageAsDefault: false,
            attachments: [],
            paymentMethod: METHOD_CARD,
        };
    }

    getMessage() {
        const vendorName = this.props.lead.vendor_name;
        const vendorContact = this.props.lead.vendor.contact_name.split(' ')[0];
        const event = this.props.lead.event;

        if (this.state.user.default_response) {
            let message = this.state.user.default_response;
            const messageData = {
                'user.first_name': event.user.first_name,
                'event.name': event.title,
                'event.date': event.date.format(Revelr.dateFormat),
                'vendor.name': vendorName,
                'vendor.contact_first': vendorContact,

            };

            Object.entries(messageData).forEach(entry => {
                const [param, value] = entry;
                message = message.replace(`{{${param}}}`, value);
            });

            return message;
        }

        return `Dear ${event.user.first_name}, great news! ${vendorContact} from ${vendorName} has responded to your inquiry. `
            + `${vendorName} is able to accommodate your event, ${event.title}, on ${event.date.format(Revelr.dateFormat)}! `
            + `Check out ${vendorName}'s profile and message ${vendorContact} back if you're interested in learning more.`;
    }

    componentWillMount() {
        if (typeof Stripe === 'undefined') {
            const script = document.createElement('script');
            script.src = 'https://js.stripe.com/v2/';
            script.async = 1;
            script.onload = () => {
                Stripe.setPublishableKey(Revelr.stripe_key);
            };

            document.body.appendChild(script);
        }

        this.api.request('/api/user/cards', {
            method: 'GET',
            success: (data) => {
                this.setState({
                    cards: data,
                    newCardOpen: !data.length,
                    cardSelected: data.length > 0 ? data[0].id : 'new',
                });
            },
        });

        super.componentWillMount();
    }

    componentDidMount() {
        if (!this.state.newMessage) {
            this.setState({ newMessage: this.getMessage() });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open !== this.state.isModalOpen) {
            this.setState({ isModalOpen: nextProps.open });
        }
    }

    handleToggle() {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    }

    handleCardFormChanged(selected, data) {
        this.setState({
            cardToken: null,
            cardSelected: selected,
            newCard: selected === 'new' ? data : {},
        });
    }

    handleMessageChanged(value) {
        this.setState({ messageModified: true, newMessage: value });
    }

    handleAttachmentsChanged(attachments, errorMessage) {
        this.setState({ attachments: attachments, newMessageError: errorMessage });
    }

    handleSaveAsDefaultChecked(field, value) {
        this.setState({ saveMessageAsDefault: value });
    }

    handleCardOptionClicked(e) {
        e.preventDefault();
        this.setState({ paymentMethod: METHOD_CARD });
    }

    handleCreditsOptionClicked(e) {
        e.preventDefault();
        this.setState({ paymentMethod: METHOD_CREDITS });
    }

    handleSubmit() {
        if (!this.state.paymentMethod && !this.props.lead.options.free) {
            return;
        }

        if (this.state.paymentMethod === METHOD_CREDITS
            && !this.state.user.unlimited_expiration
            && this.state.user.credits < 5) {
            this.props.onTooFewCredits();
            return;
        }

        this.setState({ saving: true });

        if (this.state.paymentMethod === METHOD_CREDITS || this.props.lead.options.free || this.state.cardSelected !== 'new') {
            this.submitForm();
            return;
        }

        const errors = this.form.validate(this.state.newCard);
        if (errors !== true) {
            this.setState({
                saving: false,
                errors: errors,
            });

            return;
        }

        Stripe.createToken({
            name: this.state.newCard.name,
            number: this.state.newCard.card_number,
            cvc: this.state.newCard.cvc,
            exp_month: this.state.newCard.exp_month,
            exp_year: this.state.newCard.exp_year,
        }, (status, response) => {
            if (response.error) {
                const error = {};
                error[FIELD_MAP[response.error.param]] = response.error.message;

                this.setState({
                    saving: false,
                    errors: error,
                }, () => {
                    this.tracker.logMessage('Lead payment failure', { response: response });
                });
                return;
            }

            this.setState({
                cardToken: response.id,
                errors: {},
            }, () => {
                this.submitForm();
            });
        });
    }

    submitForm() {
        if (!this.state.newMessage) {
            this.setState({
                saving: false,
                newMessageError: 'Please provide a message to send.',
            });
            return;
        }

        const data = {
            first_message: this.state.newMessage,
            attachments: this.state.attachments,
            save_response: this.state.saveMessageAsDefault,
        };

        if (this.state.paymentMethod === METHOD_CARD) {
            if (this.state.cardToken) {
                data.stripe_token = this.state.cardToken;
            } else {
                data.card = this.state.cardSelected;
            }
        } else if (this.state.paymentMethod === METHOD_CREDITS) {
            data.use_credits = true;
        }

        this.api.request(`/api/leads/${this.props.lead.id}/pay`, {
            method: 'POST',
            data: data,
            success: (response) => {
                if (response.error) {
                    this.setState({ saving: false, newMessageError: response.error }, () => {
                        this.tracker.logMessage('Error saving new message', {
                            payment_method: this.state.paymentMethod,
                            has_attachments: this.state.attachments.length > 0,
                            new_message: this.state.newMessage,
                            error: response.error,
                        });
                    });
                    return;
                }

                let message = 'Thank you for accepting this lead.';
                if (this.state.paymentMethod === METHOD_CARD && !this.props.lead.options.free) {
                    message = 'Thank you for your payment of $5.';
                }

                AlertActions.addAlert({
                    message: message,
                    type: 'success',
                });

                this.handleToggle();

                if (!this.props.lead.options.free) {
                    if (this.state.paymentMethod !== METHOD_CARD) {
                        UserActions.decreaseCredits(5);
                    }
                }

                if (this.state.saveMessageAsDefault) {
                    UserActions.updateField('default_response', this.state.newMessage);
                }

                LeadActions.saveLead(response);
            },
            error: (xhr) => {
                this.setState({
                    saving: false,
                    newMessageError: 'An unexpected error occurred, please try again or contact us if the problem persists.',
                }, () => {
                    this.tracker.logMessage('Error accepting lead', {
                        payment_method: this.state.paymentMethod,
                        has_attachments: this.state.attachments.length > 0,
                        new_message: this.state.newMessage,
                        response: xhr.responseText,
                    });
                });
            },
        });
    }

    render() {
        const lead = this.props.lead;

        return (
            <button onClick={this.handleToggle} className="btn btn-inverted">
                Yes

                <Modal show={this.state.isModalOpen} bsSize="large" onHide={this.handleToggle}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Would you like to respond to this event lead?
                        </Modal.Title>
                    </Modal.Header>

                    <div className="modal-body buy-lead">
                        <NewMessage
                            rows={10}
                            saveButton={false}
                            error={this.state.newMessageError}
                            message={this.state.newMessage}
                            attachments={this.state.attachments}
                            onChange={this.handleMessageChanged}
                            onAttachmentsChange={this.handleAttachmentsChanged}
                        />

                        {this.state.messageModified && <div>
                            <CheckboxField
                                name="save_as_default"
                                value="save_as_default"
                                label="Save as default response"
                                checked={this.state.saveMessageAsDefault}
                                onChange={this.handleSaveAsDefaultChecked}
                            />
                        </div>}

                        {!lead.options.free && this.state.user.credits > 0 && <div>
                            <h4 className="section-title">How would you like to respond to this event lead?</h4>

                            <div className="payment-choices">
                                <div className={`payment-option credits-option` + (this.state.paymentMethod === METHOD_CREDITS ? ' active' : '')} onClick={this.handleCreditsOptionClicked}>
                                    <div className="option-header">
                                        You Have {this.state.user.unlimited_expiration ? 'Unlimited' : <span className="credits-count">{this.state.user.credits}</span>} Credits
                                        {this.state.user.unlimited_expiration && ` Until ` + (this.state.user.unlimited_expiration.format(Revelr.dateFormat))}
                                    </div>
                                    <div className="option-label">Use 5 Revelr Credits to respond to this lead</div>
                                </div>

                                <div className={`payment-option card-option` + (this.state.paymentMethod === METHOD_CARD ? ' active' : '')} onClick={this.handleCardOptionClicked}>
                                    <span className="option-label">Respond for a one-time fee of $5</span>
                                </div>
                            </div>
                        </div>}

                        {lead.options.free && <h4 className="free-message">The fee for this lead has been waived. This one's on us.</h4>}
                        {!lead.options.free && this.state.paymentMethod === METHOD_CARD && <CardSelector
                            cards={this.state.cards}
                            errors={this.state.errors}
                            onFormChanged={this.handleCardFormChanged}
                        />}
                    </div>

                    <div className="modal-footer">
                        <ActiveButton
                            saving={this.state.saving}
                            onClick={this.handleSubmit}
                            actionLabel="Sending"
                            submitLabel="Submit"
                            buttonClass="btn btn-dark"
                        />
                    </div>
                </Modal>
            </button>
        );
    }
}

AcceptModal.propTypes = {
    open: PropTypes.bool,
    lead: PropTypes.object.isRequired,
    onTooFewCredits: PropTypes.func.isRequired,
};

AcceptModal.defaultProps = {
    open: false,
};

export default AcceptModal;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/leads/acceptModal.jsx